document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const onScroll = () => {
    if (!header) return;
    if (window.scrollY > 24) {
      header.classList.add('border-b','border-white/[0.06]','bg-ink-950/80','backdrop-blur-xl');
    } else {
      header.classList.remove('border-b','border-white/[0.06]','bg-ink-950/80','backdrop-blur-xl');
    }
  };
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const open = menu.hasAttribute('hidden');
      if (open) { menu.removeAttribute('hidden'); btn.classList.add('xv-menu-open'); btn.setAttribute('aria-expanded','true'); }
      else { menu.setAttribute('hidden',''); btn.classList.remove('xv-menu-open'); btn.setAttribute('aria-expanded','false'); }
    });
  });
  document.querySelectorAll('[data-mobile-menu] a').forEach(a => a.addEventListener('click', () => {
    const menu = document.querySelector('[data-mobile-menu]'); const btn = document.querySelector('[data-menu-toggle]');
    if (menu) menu.setAttribute('hidden',''); if (btn) { btn.classList.remove('xv-menu-open'); btn.setAttribute('aria-expanded','false'); }
  }));

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, {threshold:.12}) : null;
  document.querySelectorAll('.reveal').forEach(el => observer ? observer.observe(el) : el.classList.add('is-visible'));

  document.querySelectorAll('[data-youtube-id]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-youtube-id'); const title = btn.getAttribute('data-title') || 'Portfolio video';
      const wrap = btn.closest('[data-video-wrap]'); if (!id || !wrap) return;
      wrap.innerHTML = `<iframe class="absolute inset-0 h-full w-full" src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1" title="${title.replace(/"/g,'&quot;')}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy"></iframe>`;
    }, {once:true});
  });

  document.querySelectorAll('[data-faq-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.xv-faq-item'); if (!item) return;
      const wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.xv-faq-item').forEach(other => { other.classList.remove('is-open'); const b=other.querySelector('[data-faq-button]'); if(b)b.setAttribute('aria-expanded','false'); });
      if (!wasOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); }
    });
  });

  document.querySelectorAll('.xv-contact-form').forEach(form => form.addEventListener('submit', () => {
    const button = form.querySelector('button[type="submit"]'); if (!button) return;
    button.disabled = true; button.dataset.originalText = button.textContent || ''; button.textContent = 'Sending...';
  }));
});